import ReactDOM from 'react-dom/client';
import {
    BrowserRouter,
    Route,
    Routes
} from 'react-router-dom';
import App from './App';
import DeleteAccount from './components/DeleteAccount/DeleteAccount';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import './index.css';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<BrowserRouter>
<Routes>
<Route path = "/" element = {<App/>}>
</Route>
<Route path="/chamcha-privacy-policy" element={<PrivacyPolicy />} />
<Route path="/chamcha-delete-account" element={<DeleteAccount />} />
</Routes>
</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
